<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div class="actions">
	@for (action of actions; track action.iconName) {
		<globalictcc-button
			[iconName]="action.iconName"
			[iconOnly]="true"
			(handleClick)="action.onClick(rowData)"
		/>
	}
</div>
